<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex">
        <van-tab title="发起提交"></van-tab>
        <van-tab title="查看数据"></van-tab>
        <van-tab title="席位总览"></van-tab>
      </van-tabs>
    </div>
    <!--  站位盒子  -->
    <div class="h-98"></div>
    <!--  列表  -->
    <list v-if="tabIndex === 1" ref="list" @change="listChange"></list>
    <!--  表单  -->
    <addOrUpdate v-if="tabIndex === 0" ref="addOrUpdate"></addOrUpdate>
    <!--  席位总览  -->
    <seatOverview v-if="tabIndex === 2" @reserving="reserving" ref="seatOverview"></seatOverview>


  </div>
</template>
<script>
import addOrUpdate from './form.vue'
import seatOverview from "@/views/reservation/seatOverview.vue";
import list from './list.vue'

export default {
  components: {seatOverview, addOrUpdate, list},
  data() {
    return {
      tabIndex: 2,
      routeQuery: {},
    }
  },
  created() {
    this.routeQuery = this.$route.query
    if (this.routeQuery.processInstanceId) {
      this.tabIndex = 0;
    }
  },
  methods: {
    reserving(data) {
      this.tabIndex = 0;
      setTimeout(() => {
        this.$refs.addOrUpdate.setFormInfo(data)
      },500)

    },
    listChange(data) {
      console.log('this.$route.query ----------------', this.$route.query)
      const {processInstanceId, taskId} = data
      const query = {
        ...this.$route.query, processInstanceId, taskId
      }
      const url = `${window.location.origin}${window.location.pathname}?processInstanceId=${processInstanceId}&taskId=${taskId}${query.groupId ? `&groupId=${query.groupId}` : ''}${query.templateId ? `&templateId=${query.templateId}` : ''}`
      window.location.href = url
    }
  }
}

</script>



